import { useNavigate } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { useI18n } from '@/i18n';

export function NeedAccount() {
    const { t } = useI18n();
    const navigate = useNavigate();
    return (
        <div className="card-lime text-center py-8 space-y-4">
            <UserPlus className="w-10 h-10 mx-auto text-brand-300" />
            <div className="space-y-1">
                <h2 className="text-lg font-bold">{t('needAccount.title')}</h2>
                <p className="text-sm text-ink-muted">{t('needAccount.text')}</p>
            </div>
            <button className="btn-primary w-full" onClick={() => navigate('/register')}>{t('home.createAccount')}</button>
        </div>
    );
}
